module.exports = __webpack_public_path__ + "img/facetes.c6ce46d.jpg";